import React from "react";
import { kindUi, timeAgo } from "./notificationUi";

/** One notification: status pill, time, ticket and message. Unread rows are bold with a dot. */
const NotificationRow = ({ item, onClick, compact = false }) => {
    const { Icon, pill, label } = kindUi(item.to_status);
    return (
        <button type="button" className={`sn-row${item.is_read ? "" : " sn-row--unread"}`} onClick={() => onClick(item)}>
            <span className="sn-row__dot" aria-label={item.is_read ? undefined : "Unread"} />
            <span className="sn-row__body">
                <span className="sn-row__top">
                    <span className={`fd-status-pill ${pill} sn-row__pill`}><Icon size={11} /> {label}</span>
                    <span className="sn-row__time">{timeAgo(item.created_time)}</span>
                </span>
                <span className="sn-row__ticket">{item.ticket_code}{item.ticket_title ? ` · ${item.ticket_title}` : ""}</span>
                {!compact && <span className="sn-row__msg">{item.message}</span>}
            </span>
        </button>
    );
};

export default NotificationRow;
